const state = {};
const mutations = {};
export default {
  namespaced: true,
  state,
  mutations
};
